export const dateFormat = (msStr, format) => {
	return window.moment.unix(msStr).format(format);
};
